var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#7E90EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6491 24.728C19.987 24.728 16.9324 23.5807 13.6757 20.3188C11.8788 18.5193 10.4863 16.4948 9.74511 14.6275C9.11621 12.9178 9.11621 11.523 9.74511 10.8931C9.81247 10.8257 9.85744 10.7806 9.92481 10.7132C10.0371 10.5782 10.1719 10.4207 10.3066 10.2857C10.8007 9.7908 11.3623 9.27344 12.0809 9.27344C12.7098 9.27344 13.3163 9.6334 13.9451 10.4207C15.697 12.6027 14.9334 13.3676 13.9901 14.3124L13.8328 14.4699C13.6755 14.6275 13.4286 15.3022 16.0564 17.9342C17.9656 19.8464 18.8415 20.2062 19.2682 20.2062C19.3805 20.2062 19.4703 20.1611 19.5376 20.0937L19.6949 19.9361C20.2115 19.4188 20.6832 18.9463 21.4019 18.9463C21.9634 18.9463 22.7046 19.2612 23.5805 19.9812C24.2993 20.611 24.6586 21.1734 24.726 21.7358C24.7709 22.6131 24.0521 23.2881 23.4233 23.8504C23.3109 23.963 23.2212 24.0529 23.1088 24.1203C22.7946 24.5705 22.278 24.7279 21.6491 24.7279L21.6491 24.728Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallButton);
export default __webpack_public_path__ + "static/media/callButton.a56d13263eea3e9600022782d9796cc1.svg";
export { ForwardRef as ReactComponent };